<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Dedication"> PRAISE FOR NINA KIRIKI HOFFMAN</p>
<p class="ORIM-Body-Text-Line-Break">“A gifted and enigmatic author … Is Nina Hoffman a genius? Oh, yes. Yes, indeed.” —<i>Fantasy &amp; Science Fiction</i></p>
<p class="ORIM-Body-Text-Line-Break">“One of a kind, an American original … one of the finest writers working the blurry edge of fantasy and horror.” —<i>Locus</i></p>
<p class="ORIM-Dedication"><i>The Thread That Binds the Bones</i></p>
<p class="ORIM-Dedication">Winner of the Bram Stoker Award for Best First Novel</p>
<p class="ORIM-Body-Text-Line-Break">“A good story by a fine writer … High quality and mesmeric appeal.” —Roger Zelazny</p>
<p class="ORIM-Body-Text-Line-Break">“A joy to read … beautifully written and unique in its freshness of vision … What a delightful addition to the family of fantasists [Nina Hoffman] is.” —Kate Wilhelm, author of <i>Where Late the Sweet Birds Sang</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?d979deec